<style scoped lang="scss">
.day-box {
	height: 570px;
	overflow-y: scroll;
	box-shadow:  0 0 0 2px #c9e1f0;
	border-radius: 5px;
}
.date-info {
	display: flex; flex-direction: row; align-items: center; justify-content: center;
	background-color: #3399ff;
	color: white;
	border-radius: 5px;
	padding: 5px 0;
	border-bottom: solid 1px #c9e1f0;
	.right {
		margin-left: 20px;
		cursor: pointer;
	}
}
.bb {
	border-bottom: solid 1px #c9e1f0;
}
.thr {
	background-color: #e8f6ff;
}
.th {
	display: flex; flex-direction: row; align-items: center;
	
	border-bottom: solid 1px #c9e1f0;
	color: #003f94;
	.week {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 120px;
		border-right: solid 1px #c9e1f0;
		border-left: solid 1px #c9e1f0;
	}
	.comp {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 100px;
		border-right: solid 1px #c9e1f0;
	}
	.time {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 100px;
		border-right: solid 1px #c9e1f0;
	}
	.vs {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 220px;
		border-right: solid 1px #c9e1f0;
	}
	.goal {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 100px;
		border-right: solid 1px #c9e1f0;
		.sub-goal {
			height: 40px;
			line-height: 40px;
			position: relative;
		}
		.single {
			position: absolute;
			top: 0;
			left: 0;
			font-size: 12px;
			width: 20px;
			height: 20px;
			line-height: 20px;
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			text-align: center;
			color: #ffffff;
			background-color: red;
		}
	}
	.h,.d,.a {
		height: 81px;
		line-height: 81px;
		width: 80px;
		text-align: center;
		border-right: solid 1px #c9e1f0;
		.bet-odds {
			height: 40px;
			line-height: 40px;
			cursor: pointer;
		}
	}
	.more {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 80px;
		border-right: solid 1px #c9e1f0;
		color: #888888;
		cursor: pointer;
	}
	.result {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 340px;
		border-right: solid 1px #c9e1f0;
	}
}

.more-box {
	padding: 14px 10px 5px 10px;
	border-right: solid 1px #c9e1f0;
	border-left: solid 1px #c9e1f0;
	border-bottom: solid 1px #c9e1f0;
	background-color: #c9e1f0;
	.more-line {
		display: flex; flex-direction: row; align-items: flex-start;
		border-bottom: solid 1px #c9e1f0;
		.more-name {
			width: 120px;
			text-align: center;
			border: solid 1px #c9e1f0;
			margin-bottom: 10px;
			background-color: white;
		}
		.bqc {
			height: 41px;
			line-height: 41px;
		}
		.bf {
			height: 125px;
			line-height: 123px;
		}
		.more-bets {
			
			background-color: white;
			.more-line {
				.more-bet {
					height: 41px;
					width: 82px;
					border-right: solid 1px #c9e1f0;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					.more-bet-name {
						font-weight: bold;
						color: #333333;
					}
					.more-bet-odds {
						color: #888888;
					}
				}
				.active {
					background-color: orangered;
					color: white;
					.more-bet-name {
						font-weight: bold;
						color: #FFFFFF!important;
					}
					.more-bet-odds {
						color: #FFFFFF!important;
					}
				}
			}
		}
	}
}
.tools-line {
	background-color: white; padding: 10px; border-radius: 10px; display: flex; flex-direction: row; align-items: center; justify-content: space-between; margin-top: 10px;
	box-shadow:  0 0 0 2px #EFEFEF;
}
</style>
<template>
	<div>
		<div class="day-box">
			<div v-for="(dayItem, index) in matchList" :key="dayItem.date">
				<div class="date-info">
					<div>{{dayItem.date}} {{dayItem.week}} {{dayItem.list.length}}场比赛</div>
					<div v-show="dayItem.is_open" @click="dayItem.is_open=false" class="right">关闭</div>
					<div v-show="!dayItem.is_open" @click="dayItem.is_open=true" class="right">展开</div>
				</div>
				<div class='th thr' v-if="dayItem.is_open">
					<div class='week'>赛事编号</div>
					<div class='comp'>赛事</div>
					<div class='time'>开赛时间</div>
					<div class='vs'>主队 VS 客队</div>
					<div class='goal'>让球</div>
					<div class='h'>胜</div>
					<div class='d'>平</div>
					<div class='a'>负</div>
					<div class='more'>展开</div>
					<div class='result'>赛果</div>
				</div>
				<div  v-for="(match, matchInx) in dayItem.list" :key="match.match_id" v-if="dayItem.is_open">
					<footballMatch :match="match" :reset="resetTimestamp" :totalMatches="totalMatches" @toggle="toggleSelect"></footballMatch>
				</div>
			</div>
		</div>
		<div class="tools-line">
			<div>
				<div style="padding-left: 20px;">
				  过关方式：
				  <el-radio v-model="passType" :label="1">M串N</el-radio>
				  <el-radio v-model="passType" :label="2">自由过关</el-radio>
				</div>
				
				<div style="padding: 5px 0;">
				  <!-- M串N 选项 -->
				  <div v-show="passType == 1 && totalMatches > 0" class="pass-option">
				    <el-radio-group v-model="checkedMxN">
				      <el-radio :label="item" v-for="(item, index) in groupPassList" :key="'a' + index">{{ item }}</el-radio>
				    </el-radio-group>
				  </div>
				
				  <!-- 自由过关选项 -->
				  <div v-show="passType == 2 && totalMatches > 0" class="pass-option">
				    <el-checkbox-group v-model="checkedFree">
				      <el-checkbox :value="item" :label="item" v-for="(item, index) in freePassList" :key="'b' + index">{{ item }}</el-checkbox>
				    </el-checkbox-group>
				  </div>
				</div>
			</div>
			<div>
				倍数
				<el-input-number size="small" v-model="multiplier" :min="1" :max="99999" label="描述文字"></el-input-number>
			</div>
			<div>
				<div>投注金额：<span style="color:red;">{{betCount * 2 * multiplier}}</span> 元</div>
				<div>预计奖金：{{getPreviewAwardString}}</div>
			</div>
		</div>
		<div class="tools-line">
			<div style="display: flex; flex-direction: row; align-items: center;">
				<div style="width: 50px;">宣言：</div>
				<el-select v-model="notice" placeholder="请选择" clearable style="width: 800px;">
					<el-option
						v-for="item in followList"
						:key="item.follow_desc"
						:label="item.follow_desc"
						:value="item.follow_desc">
					</el-option>
				</el-select>
				
				<el-button size="small" type="success" style="margin-left: 10px;" @click="quickSelect()">手动输入</el-button>
			</div>
			<div>
				<el-button size="small" type="danger" @click="getMatchData">重置</el-button>
				<el-button size="small" type="primary" @click="savePlan()">保存方案</el-button>
			</div>
		</div>
		
		<el-dialog :visible.sync="quickShow" v-if="quickShow" append-to-body top="300px" width="1200px" :before-close="handleClose">
			<quickSelectView></quickSelectView>
		</el-dialog>
				
	</div>
</template>

<script>
	
	import quickSelectView from './quickSelect.vue';
	import footballMatch from './footballMatch.vue';
	
	export default {
		props:['lottery_sign', 'date'],
		components: {  
			footballMatch, quickSelectView
		},
		computed:{
			orderAmount(){
				return this.betCount * 2 * this.multiplier;
			},
			getPreviewAwardString(){
				if(this.minPreviewAward == 0 && this.maxPreviewAward == 0){
					return '-';
				}else if(this.maxPreviewAward == 0 || this.minPreviewAward == 0){
					return this.maxPreviewAward  > this.minPreviewAward ? (this.maxPreviewAward * this.multiplier).toFixed(2) : (this.minPreviewAward * this.multiplier).toFixed(2);
				}else if(this.maxPreviewAward == this.minPreviewAward){
					return (this.maxPreviewAward * this.multiplier).toFixed(2);
				}
				return (this.minPreviewAward * this.multiplier).toFixed(2) + '-' + (this.maxPreviewAward * this.multiplier).toFixed(2);
			},
		},
		data(){
			return {
				notice:'',
				resetTimestamp:0,
				MxNList:[
					[], [],
					['2串1'],['3串1', '3串3', '3串4'], ['4串1', '4串4', '4串5', '4串6', '4串11'],
					['5串1', '5串5', '5串6', '5串10', '5串16', '5串20', '5串26'],
					['6串1', '6串6', '6串7', '6串15', '6串20', '6串22', '6串35', '6串42', '6串50', '6串57'],
					['7串1', '7串7', '7串8', '7串21', '7串35', '7串120'],
					['8串1', '8串8', '8串9', '8串28', '8串56', '8串70', '8串247']
				],
				MxNArr:{
				  "单关":[1], "2串1": [2], "3串1": [3], "3串3": [2], "3串4": [2,3], "4串1": [4], "4串4": [3], "4串5": [3,4], "4串6": [2],
				  "4串11": [2,3,4], "5串1": [5], "5串5": [4], "5串6": [4,5], "5串10": [2], "5串16": [3,4,5], "5串20": [2,3], "5串26": [2,3,4,5],"6串1": [6],
				  "6串6": [5], "6串7": [5,6], "6串15": [2], "6串20": [3], "6串22": [4,5,6], "6串35": [2,3], "6串42": [3,4,5,6], "6串50": [2,3,4],
				  "6串57": [2,3,4,5,6], "7串1": [7], "7串7": [6], "7串8": [6,7], "7串21": [5], "7串35": [4], "7串120": [2,3,4,5,6,7],
				  "8串1": [8],"8串8": [7], "8串9": [8,7], "8串28": [6], "8串56": [5], "8串70": [4], "8串247": [2,3,4,5,6,7,8]
				},
				multiplier:1,
				matchList:[],
				debounceTimer: null,
				debounceTimer1: null,
				betMatch:[],
				trimedBetMatch:[],
				selectedMap: new Map(),
				totalMatches:0,
				totalBets:0,
				isAllSingle:false,
				poolList:[],
				mxn_sort: ['单关', '2串1', '3串1', '4串1', '5串1', '6串1', '7串1', '8串1'],
				groupPassList:[],
				freePassList:[],
				checkedFree:[],
				checkedMxN:'',
				passType:1,
				betCount:0,
				
				minPreviewAward:0,
				maxPreviewAward:0,
				quickShow:false,
				followList:[],
			}
		},
		watch:{
			lottery_sign(_new, _old){
				this.getMatchData();
			},
			date(_new, _old){
				this.getMatchData();
			},
			passType(_new, _old){
				this.calc();
			},
			checkedMxN(_new, _old){
				this.calc();
			},
			checkedFree(_new, _old){
				this.calc();
			}
		},
		mounted(){
			this.getFollowDescList();
		},
		beforeUnmount() {
		},
		methods:{
			savePlan(){
				let _pool = '';
				let _stopTime = '';
				let _betArrs = [];
				let _betString = '';
				this.trimedBetMatch.forEach((v,k)=>{
					let _tmp_matchInfo = v[0][0];
					let _matchInfo = {
						match_id: _tmp_matchInfo.match_id,
						issue_week: _tmp_matchInfo.weekStr,
						issue_num: _tmp_matchInfo.weekNo,
						home: _tmp_matchInfo.home,
						away: _tmp_matchInfo.away,
						comp: _tmp_matchInfo.comp,
						stop_time: _tmp_matchInfo.stop_time,
						issue: _tmp_matchInfo.issue,
						match_time: _tmp_matchInfo.matchTime,
						betItems:[]
					}
					_betString += _tmp_matchInfo.weekStr + '@';
					let _matchArr = [];
					v.forEach((vv,kk)=>{
						let _poolArr = [];
						vv.forEach((vvv,kkk)=>{
							if(_stopTime == ''){
								_stopTime = vvv.stop_time;
							}else if(_stopTime > vvv.stop_time ){
								_stopTime = vvv.stop_time;
							}
							if(_pool == ''){
								_pool = vvv.pool
							}else if(_pool != vvv.pool){
								_pool = 'hhgg';
							}
							let _betItem = {
								bet:vvv.bet,
								betName:vvv.betName,
								pool:vvv.pool,
								poolName:this.getPoolName(vvv.pool, vvv.goal),
								odds:vvv.odds,
								goal:vvv.goal,
								single:vvv.single,
								match_id:vvv.match_id,
								weekNo:vvv.weekNo,
								home:vvv.home,
								away:vvv.away,
								issue:vvv.issue,
								weekStr:vvv.weekStr,
								matchTime:vvv.matchTime
							}
							_betString += vvv.betName + '，'
							_poolArr.push(_betItem);
						})
						_matchArr.push(_poolArr);
					})
					_matchInfo.betItems = _matchArr;
					_betArrs.push(_matchInfo)
				})
				let form = {
					matchList:_betArrs,
					lotterySign:'football',
					lotteryName:'竞彩足球',
					multiplier:this.multiplier,
					betCount:this.betCount,
					previewAward:this.getPreviewAwardString,
					passList:JSON.stringify(this.getPassList()),
					stopTime:_stopTime,
					playType:_pool,
					orderAmount:this.orderAmount,
					must_ticket:0,
					is_follow:1,
					follow_private:1,
					follow_desc:this.notice
				}
				this.$emit('addPlan', {form:form, betString:_betString, lotteryName:'竞彩足球', multiplier:this.multiplier, date:this.date, orderAmount:this.orderAmount});
			},
			getFollowDescList(){
				let _this  = this;
				const _loading = this.$loading({ lock: true, text: '加载宣言中..', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
				_this.$api.post("/Virtuals/getFollowDesc", {}).then(res=>{
					_loading.close();
					if(res.code == 200){
						_this.followList = res.data.list;
					}
				}).catch(err=>{
					_loading.close();
				})
			},
			handleClose(){
				this.quickShow = false;
			},
			quickSelect(){
				this.quickShow = true;
			},
			getPassList(){
				if(this.passType == 1 && this.checkedMxN != ''){
					return [this.checkedMxN];
				}
				if(this.passType == 2){
					return this.checkedFree;
				}
				return [];
			},
			changePassList(_currentPass){
				let passArr = [];
				for(let i = 0; i < _currentPass.length; i++){
					passArr = passArr.concat(this.MxNArr[_currentPass[i]]);
				}
				return passArr;
			},
			calc(){
				if(this.debounceTimer1) clearTimeout(this.debounceTimer1);
				this.debounceTimer1 = setTimeout(() => {
					this.realCalc();
				}, 300);
			},
			realCalc(){
				const passList = this.getPassList();
				// 算注数
				this.betCount = 0;
				if(passList.length == 0){
					this.minPreviewAward = 0;
					this.maxPreviewAward = 0;
					return;
				} 
				let passArr = this.changePassList(passList);
				// 拆票
				let unSplitMethod = [];
				let objArr = this.betMatch;
				for (let key in objArr) {
					let maxArr = [];
					if (objArr.hasOwnProperty(key)) {
						let poolArr = objArr[key];
						let subArr = [];
						for(let poolKey in poolArr){
							subArr.push(poolArr[poolKey]);
						}
						unSplitMethod.push(subArr);
					}
				}
				this.trimedBetMatch = unSplitMethod;
				let splitedMethod = this.generateCombinations(unSplitMethod, unSplitMethod.length, 1);
				let singledMethod = [];
				if(passArr.includes(1)){
					singledMethod = this.splitSingleTickets(unSplitMethod);
				}
				let SplitTimes = [];
				splitedMethod.forEach((v,k)=>{
					let unSplitTimes = [];
					v.forEach((vv,kk)=>{
						unSplitTimes.push(vv);
					})
					passArr.forEach((psM, i)=>{
						if(psM != 1){
							let _t = this.generateCombinations(unSplitTimes, psM, 1);
							SplitTimes = SplitTimes.concat(_t);
						}
					});
				});
				if(passArr.includes(1)){
					singledMethod.forEach((v,k)=>{
						let unSplitTimes = [];
						v.forEach((vv,kk)=>{
							unSplitTimes.push(vv);
						})
						let _t = this.generateCombinations(unSplitTimes, 1, 1);
						SplitTimes = SplitTimes.concat(_t);
					});
				}
				
				this.betCount += SplitTimes.length; 
				this.CalcPreviewAward();
			},
			splitSingleTickets(_arr){
				let _poolList = [];
				let _newArr = [];
				for(let i = 0; i < _arr.length; i++){
					let _match = _arr[i]; // i 等同于 match_id
					for(let j = 0; j < _match.length; j++){
						let _method = _match[j];
						
						for(let k = 0; k < _method.length; k++){
							let _bet = _method[k];
							let _pos = _poolList.indexOf(_bet.pool);
							if( _pos === -1 ){
								_poolList.push(_bet.pool);
								_newArr[_poolList.length - 1] = [];
								_pos = _poolList.length - 1;
							}
							if(!_newArr[_pos][i]){
								_newArr[_pos][i] = [];
							}
							_newArr[_pos][i].push(_bet);
						}
					}
				}
				return _newArr;
			},
			generateCombinations(arr, m, n) {
			    const result = [];
			    function combinationHelper(arr, m, n, start, currentCombination) {
			        if (currentCombination.length === m) {
			            result.push(currentCombination);
			            return;
			        }
			        for (let i = start; i <= arr.length - (m - currentCombination.length); i++) {
			            for (const v of arr[i]) {
			                combinationHelper(arr, m, n, i + 1, currentCombination.concat([v]));
			            }
			        }
			    }
			    combinationHelper(arr, m, n, 0, []);
			    return result;
			},
			reset(){
				this.selectedMap = new Map();
				this.betMatch = [];
				this.isAllSingle = false;
				this.totalMatches = 0;
				this.totalBets = 0;
				this.groupPassList = [];
				this.freePassList = [];
				this.checkedFree = [];
				this.checkedMxN = '';
				this.passType = 1 ;
				this.poolList = [];
				this.resetTimestamp = new Date().getTime();
			},
			trimPassList(){
				let _groupPassList = [];
				let _freePassList = [];
				if(this.totalMatches < 1){
					this.groupPassList = [];
					this.freePassList = [];
					this.calc();
					return;
				}
				if(this.isAllSingle){
					_freePassList.push('单关');
				}
				let _max_pass = this.totalMatches;
				let _has_ttg = false;
				let _has_hafu = false;
				let _has_crs = false;
				let _has_group = true;
				let _has_wnm = false;
				
				if(this.poolList.includes('ttg')) _has_ttg = true;
				if(this.poolList.includes('crs')) _has_crs = true;
				if(this.poolList.includes('hafu')) _has_hafu = true;
				if(this.poolList.includes('wnm')) _has_wnm = true;
				
				if(_has_ttg && this.totalMatches > 6){
					_max_pass = 6;
					_has_group= false;
				}
				if( (_has_crs || _has_hafu || _has_wnm) && this.totalMatches > 4){
					_max_pass = 4;
					_has_group= false;
				}
				for(let i = 2; i <= _max_pass; i++){
					_freePassList.push(i + '串1');
				}
				const _t = this.MxNList[this.totalMatches];
				_t.forEach((v,k)=>{
					_groupPassList.push(v);
				})
				
				if(!_has_group){
					_groupPassList = [];
				}
				
				this.groupPassList = _groupPassList;
				this.freePassList = _freePassList;
				
				this.checkedMxN = '';
				this.checkedFree = [];
				if(this.passType == 1 && _groupPassList.length > 0){
					this.checkedMxN = _groupPassList[0];
				}
				if(this.passType == 2 && _freePassList.length > 0){
					this.passType = 2;
					this.checkedFree.push(_freePassList[0]);
				}
				this.calc();
			},
			toggleSelect(_match, _pool, _bet){
				const _key = `${_match.match_id}@${_pool}@${_bet}`
				if(this.selectedMap.has(_key)){
					this.selectedMap.delete(_key)
				}else{
					let _goal = _match[_pool].goal ?? '';
					let _betObj = {
						match_id:_match.match_id,
						bet:_bet,
						betName: this.getBetName(_pool, _bet),
						pool: _pool,
						goal: _goal,
						poolName:this.getPoolName(_pool, _goal),
						single:_match[_pool].single,
						odds:_match[_pool][_bet],
						weekNo:_match.issue_num,
						home:_match.home,
						away:_match.away,
						issue:_match.issue,
						weekStr:_match.issue_week,
						matchTime:_match.match_time,
						comp:_match.comp,
						stop_time:_match.stop_time,
						option: this.getBetName(_pool, _bet) + ((_goal != '' && _goal != 0) ? _goal : ''),
					}
					this.selectedMap.set(_key, _betObj);
				}
				// 整理数据 - 防抖
				this.trimBetMatch();
				return;
				if(this.debounceTimer) clearTimeout(this.debounceTimer);
				this.debounceTimer = setTimeout(() => {
					
				}, 300);
			},
			trimBetMatch() {
				let poolList = [];
				let isAllSingle = true;
				const tempMap = {}; // 按 match_id 分组
				const selectedMap = this.selectedMap; // Map 对象
				// 遍历 selectedMap，按 match_id 分组，同时判断是否全单式、是否混合过关
				selectedMap.forEach((v) => {
					// 判断是否混合过关
					if(!poolList.includes(v.pool)){
						poolList.push(v.pool);
					}
					// 判断是否全单式
					if (!v.single) {
						isAllSingle = false;
					}
					// 按 match_id 分组
					if (!tempMap[v.match_id]) {
						tempMap[v.match_id] = [];
					}
					tempMap[v.match_id].push(v);
				});
				//按 pool 再分组
				const betMatch = {};
				let totalBets = 0; // 总选项数
				for (const matchId in tempMap) {
					const bets = tempMap[matchId];
					betMatch[matchId] = {};
					bets.forEach(betline => {
						if (!betMatch[matchId][betline.pool]) {
							betMatch[matchId][betline.pool] = [];
						}
						betMatch[matchId][betline.pool].push(betline);
						totalBets++;
					});
				}

				this.isAllSingle = isAllSingle;
				this.poolList = poolList;
				this.betMatch = betMatch;
				this.totalMatches = Object.keys(betMatch).length;
				this.totalBets = totalBets;
				this.trimPassList();
			},
			moreFunc(_match){
				if(_match.isMore){
					_match.isMore = false;
				}else{
					this.$set(_match, 'isMore', true);
				}
			},
			getMatchData(){
				if(this.lottery_sign != '' && this.date != ''){
					let _this  = this;
					const _loading = this.$loading({ lock: true, text: '加载场次中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
					_this.$api.post("/Game/getFootballOdds", {lottery_sign:_this.lottery_sign, date:_this.date}).then(res=>{
						_loading.close();
						if(res.code == 200){
							_this.matchList = res.data.list;
							_this.reset();
						}
					}).catch(err=>{
						_loading.close();
					})
				}
			},
			CalcPreviewAward(){
				let _matches = [];
				let _matchId_list = [];
				
				let _newMatches = this.trimedBetMatch;
				let _passList = this.getPassList();
				
				let bestMatchBeting = this.p_getFootballBetListAllMaxMin(_newMatches);
				
				let mul_single_ticket_arr = [];
				if(_passList.includes('单关')){
					mul_single_ticket_arr = this.get_mul_single_ticket_arr(_newMatches);
				 }
				let mul_ticket_arr = this.p_generate_combinations(_newMatches, _newMatches.length, 1);
				let _max_money = 0;
				let _min_money = 99999999999;
				
				_passList.forEach((pass,k)=>{
					let _arrs = this.MxNArr[pass];
					if(pass != '单关'){
						_arrs.forEach((_mxn,kk)=>{
							mul_ticket_arr.forEach((_ticket)=>{
								let _ticket_com = this.p_generate_combinations(_ticket, _mxn, 1);
								_ticket_com.forEach((_ticket_line)=>{
									let _sp = 1;
									let _award = 0;
									let _mcount = 0;
									_ticket_line.forEach((_bet)=>{
										let _res = this.checkBestInBet(_bet, bestMatchBeting["max_matchs"]);
										
										if(_res) {
											_sp = _sp * _bet['odds'];
										}else{
											_sp = 0;
										}
										_award = this.myFixed(_sp * 2);
										_mcount += 1;
									})
									_award = this.lotteryLimit(_award, _mcount);
									_max_money = parseFloat(_max_money) + parseFloat(_award);
								})
							})
						})
					}else{
						mul_single_ticket_arr.forEach((_ticket)=>{
							let _ticket_com = this.p_generate_combinations(_ticket, 1, 1);
							_ticket_com.forEach((_ticket_line)=>{
								let _sp = 1;
								let _award = 0;
								let _mcount = 0;
								_ticket_line.forEach((_bet)=>{
									let _res = this.checkBestInBet(_bet, bestMatchBeting["max_matchs"]);
									
									if(_res) {
										_sp = _sp * _bet['odds'];
									}else{
										_sp = 0;
									}
									_award = this.myFixed(_sp * 2);
									_mcount += 1;
								})
								_award = this.lotteryLimit(_award, _mcount);
								_max_money = parseFloat(_max_money) + parseFloat(_award);
							})
						})
					}
				})
				_passList.forEach((pass,k)=>{
					let _arrs = this.MxNArr[pass];
					if(pass != '单关'){
						_arrs.forEach((_mxn,kk)=>{
							mul_ticket_arr.forEach((_ticket)=>{
								let _ticket_com = this.p_generate_combinations(_ticket, _mxn, 1);
								_ticket_com.forEach((_ticket_line)=>{
									let _sp = 1;
									let _award = 0;
									let _mcount = 0;
									_ticket_line.forEach((_bet)=>{
										let _res = this.checkBestInBet(_bet, bestMatchBeting["min_matchs"]);
										
										if(_res) {
											_sp = _sp * _bet['odds'];
										}else{
											_sp = 0;
										}
										_award = this.myFixed(_sp * 2);
										_mcount += 1;
									})
									_award = this.lotteryLimit(_award, _mcount);
									if(parseFloat(_award) != 0 && parseFloat(_min_money) > parseFloat(_award)){
										_min_money = _award;
									}
								})
							})
						})
					}else{
						mul_single_ticket_arr.forEach((_ticket)=>{
							let _ticket_com = this.p_generate_combinations(_ticket, 1, 1);
							_ticket_com.forEach((_ticket_line)=>{
								let _sp = 1;
								let _award = 0;
								let _mcount = 0;
								_ticket_line.forEach((_bet)=>{
									let _res = this.checkBestInBet(_bet, bestMatchBeting["min_matchs"]);
									
									if(_res) {
										_sp = _sp * _bet['odds'];
									}else{
										_sp = 0;
									}
									_award = this.myFixed(_sp * 2);
									_mcount += 1;
								})
								_award = this.lotteryLimit(_award, _mcount);
								if(parseFloat(_award) != 0 && parseFloat(_min_money) > parseFloat(_award)){
									_min_money = _award;
								}
							})
						})
					}
				})
				this.minPreviewAward =  this.myFixed(_min_money);
				this.maxPreviewAward = this.myFixed(_max_money);
				console.log(this.minPreviewAward, this.maxPreviewAward);
			},
			getPoolName(_pool, _goal){
				let _poolName = '';
				switch(_pool){
					case 'had': _poolName = '胜平负'; break;
					case 'hhad': _poolName = '让球' + _goal; break;
					case 'crs': _poolName = '比  分'; break;
					case 'ttg': _poolName = '总进球'; break;
					case 'hafu': _poolName = '半全场'; break;
				}
				return _poolName;
			},
			getBetName(_pool, _bet){
				if(_pool == 'had'){
					if(_bet == 'h') return '胜';
					if(_bet == 'd') return '平';
					if(_bet == 'a') return '负';
				}
				if(_pool == 'hhad'){
					if(_bet == 'h') return '让胜';
					if(_bet == 'd') return '让平';
					if(_bet == 'a') return '让负';
				}
				if(_pool == 'ttg'){
					if(_bet == 's0') return '0球';
					if(_bet == 's1') return '1球';
					if(_bet == 's2') return '2球';
					if(_bet == 's3') return '3球';
					if(_bet == 's4') return '4球';
					if(_bet == 's5') return '5球';
					if(_bet == 's6') return '6球';
					if(_bet == 's7') return '7+球';
				}
				if(_pool == 'hafu'){
					if(_bet == 'hh') return '胜胜';
					if(_bet == 'hd') return '胜平';
					if(_bet == 'ha') return '胜负';
					if(_bet == 'dh') return '平胜';
					if(_bet == 'dd') return '平平';
					if(_bet == 'da') return '平负';
					if(_bet == 'ah') return '负胜';
					if(_bet == 'ad') return '负平';
					if(_bet == 'aa') return '负负';
				}
				if(_pool == 'crs'){
					if(_bet == 's01s00') return '1:0';
					if(_bet == 's02s00') return '2:0';
					if(_bet == 's02s01') return '2:1';
					if(_bet == 's03s00') return '3:0';
					if(_bet == 's03s01') return '3:1';
					if(_bet == 's03s02') return '3:2';
					if(_bet == 's04s00') return '4:0';
					if(_bet == 's04s01') return '4:1';
					if(_bet == 's04s02') return '4:2';
					if(_bet == 's05s00') return '5:0';
					if(_bet == 's05s01') return '5:1';
					if(_bet == 's05s02') return '5:2';
					if(_bet == 's1sh')   return '胜其它';
					
					if(_bet == 's00s00') return '0:0';
					if(_bet == 's01s01') return '1:1';
					if(_bet == 's02s02') return '2:2';
					if(_bet == 's03s03') return '3:3';
					if(_bet == 's1sd')   return '平其它';
					
					if(_bet == 's00s01') return '0:1';
					if(_bet == 's00s02') return '0:2';
					if(_bet == 's01s02') return '1:2';
					if(_bet == 's00s03') return '0:3';
					if(_bet == 's01s03') return '1:3';
					if(_bet == 's02s03') return '2:3';
					if(_bet == 's00s04') return '0:4';
					if(_bet == 's01s04') return '1:4';
					if(_bet == 's02s04') return '2:4';
					if(_bet == 's00s05') return '0:5';
					if(_bet == 's01s05') return '1:5';
					if(_bet == 's02s05') return '2:5';
					if(_bet == 's1sa')   return '负其它';
				}
				return false;
			},
			get_mul_single_ticket_arr(_arr){
				let _poolList = [];
				let _newArr = [];
				for(let i = 0; i < _arr.length; i++){
					let _match = _arr[i]; // i 等同于 match_id
					for(let j = 0; j < _match.length; j++){
						let _method = _match[j];
						
						for(let k = 0; k < _method.length; k++){
							let _bet = _method[k];
							let _pos = _poolList.indexOf(_bet.types);
							if( _pos === -1 ){
								_poolList.push(_bet.types);
								_newArr[_poolList.length - 1] = [];
								_pos = _poolList.length - 1;
							}
							if(!_newArr[_pos][i]){
								_newArr[_pos][i] = [];
							}
							_newArr[_pos][i].push(_bet);
						}
					}
				}
				return _newArr;
			},
			isEqual(a, b) {
				return JSON.stringify(a) === JSON.stringify(b);
			},
			uniqueSubarrays(arr) {
				const result = [];
				arr.forEach(sub => {
					const isDup = result.some(existing => this.isEqual(existing, sub));
					if (!isDup) {
						result.push(sub);
					}
				});
				return result;
			},
			checkBestInBet(_bet, _best){
				let _flg = false;
				_best.forEach((_match)=>{
					_match.forEach((_a)=>{
						if(_bet['match_id'] == _a['match_id'] && _bet['option'] == _a['option']){
							_flg = true;
						}
					})
				})
				return _flg;
			},
			p_generate_combinations(arr, m, n) {
			  const result = [];
			
			  function combinationHelper(arr, m, n, start, currentCombination) {
				if (currentCombination.length === m) {
				  result.push(currentCombination);
				  return;
				}
				// 最大起始索引
				for (let i = start; i <= arr.length - (m - currentCombination.length); i++) {
				  // 如果 arr[i] 不是数组，就把它包成 [arr[i]]
				  const bucket = Array.isArray(arr[i]) ? arr[i] : [arr[i]];
				  for (const v of bucket) {
					combinationHelper(
					  arr,
					  m,
					  n,
					  i + 1,
					  currentCombination.concat([v])
					);
				  }
				}
			  }
			
			  combinationHelper(arr, m, n, 0, []);
			  return result;
			},
			p_getFootballBetListAllMaxMin(_matches){
				let valid_arr = {};
					valid_arr['胜'] = ['1:0','2:0','2:1','3:0','3:1','3:2','4:0','4:1','4:2','5:0','5:1','5:2',
									 '胜其它','1球','2球','3球','4球','5球','6球','7+球',
									 '胜胜','平胜','负胜',
									 '让胜+1','让胜+2','让胜+3','让胜+4','让胜+5','让胜+6','让胜+7',
									 '让胜-1','让胜-2','让胜-3','让胜-4','让胜-5','让胜-6','让胜-7',
									 '让负-2','让负-3','让负-4','让负-5','让负-6','让负-7',
									 '让平-1','让平-2','让平-3','让平-4','让平-5','让平-6','让平-7'];
					valid_arr['平'] = ['0:0','1:1','2:2','3:3','平其它',
									 '0球','2球','4球','6球','7+球',
									 '胜平','平平','负平',
									 '让胜+1','让胜+2','让胜+3','让胜+4','让胜+5','让胜+6','让胜+7',
									 '让负-1','让负-2','让负-3','让负-4','让负-5','让负-6','让负-7'];
					valid_arr['负'] = ['0:1','0:2','1:2','0:3','1:3','2:3','0:4','1:4','2:4','0:5','1:5','2:5','负其它',
									 '1球','2球','3球','4球','5球','6球','7+球',
									 '胜负','平负','负负',
									 '让负+1','让负+2','让负+3','让负+4','让负+5','让负+6','让负+7',
									 '让负-1','让负-2','让负-3','让负-4','让负-5','让负-6','让负-7',
									 '让胜+2','让胜+3','让胜+4','让胜+5','让胜+6','让胜+7',
									 '让平+1','让平+2','让平+3','让平+4','让平+5','让平+6','让平+7'];
				
					valid_arr['让胜+1'] = ['1:0','2:0','2:1','3:0','3:1','3:2','4:0','4:1','4:2','5:0','5:1','5:2',
										 '胜其它','0:0','1:1','2:2','3:3','平其它',
										 '0球','1球','2球','3球','4球','5球','6球','7+球',
										 '胜胜','平胜','负胜','胜平','平平','负平'];
					valid_arr['让胜+2'] = ['1:0','2:0','2:1','3:0','3:1','3:2','4:0','4:1','4:2','5:0','5:1','5:2',
										 '胜其它','0:0','1:1','2:2','3:3','平其它',
										 '0:1','1:2','2:3','负其它',
										 '0球','1球','2球','3球','4球','5球','6球','7+球',
										 '胜胜','胜平','胜负','平胜','平平','平负','负胜','负平','负负'];
					valid_arr['让胜+3'] = ['1:0','2:0','2:1','3:0','3:1','3:2','4:0','4:1','4:2','5:0','5:1','5:2',
										 '胜其它','0:0','1:1','2:2','3:3','平其它',
										 '0:1','0:2','1:2','1:3','2:3','2:4','负其它',
										 '0球','1球','2球','3球','4球','5球','6球','7+球',
										 '胜胜','胜平','胜负','平胜','平平','平负','负胜','负平','负负'];
					valid_arr['让胜+4'] = ['1:0','2:0','2:1','3:0','3:1','3:2','4:0','4:1','4:2','5:0','5:1','5:2',
										 '胜其它','0:0','1:1','2:2','3:3','平其它',
										 '0:1','0:2','1:2','0:3','1:3','2:3','1:4','2:4','2:5','负其它',
										 '0球','1球','2球','3球','4球','5球','6球','7+球',
										 '胜胜','胜平','胜负','平胜','平平','平负','负胜','负平','负负'];
					valid_arr['让胜+5'] = ['1:0','2:0','2:1','3:0','3:1','3:2','4:0','4:1','4:2','5:0','5:1','5:2',
										 '胜其它','0:0','1:1','2:2','3:3','平其它',
										 '0:1','0:2','1:2','0:3','1:3','2:3','0:4','1:4','2:4','1:5','2:5','负其它',
										 '0球','1球','2球','3球','4球','5球','6球','7+球',
										 '胜胜','胜平','胜负','平胜','平平','平负','负胜','负平','负负'];
					valid_arr['让胜+6'] = ['1:0','2:0','2:1','3:0','3:1','3:2','4:0','4:1','4:2','5:0','5:1','5:2',
										 '胜其它','0:0','1:1','2:2','3:3','平其它',
										 '0:1','0:2','1:2','0:3','1:3','2:3','0:4','1:4','2:4','0:5','1:5','2:5','负其它',
										 '0球','1球','2球','3球','4球','5球','6球','7+球',
										 '胜胜','胜平','胜负','平胜','平平','平负','负胜','负平','负负'];
					valid_arr['让胜+7'] = ['1:0','2:0','2:1','3:0','3:1','3:2','4:0','4:1','4:2','5:0','5:1','5:2',
										 '胜其它','0:0','1:1','2:2','3:3','平其它',
										 '0:1','0:2','1:2','0:3','1:3','2:3','0:4','1:4','2:4','0:5','1:5','2:5','负其它',
										 '0球','1球','2球','3球','4球','5球','6球','7+球',
										 '胜胜','胜平','胜负','平胜','平平','平负','负胜','负平','负负'];
				
					valid_arr['让平+1'] = ['0:1','1:2','2:3','负其它','1球','3球','5球','7+球','平负','负负','胜负'];
					valid_arr['让平+2'] = ['0:2','1:3','2:4','负其它','2球','4球','6球','7+球','平负','负负','胜负'];
					valid_arr['让平+3'] = ['0:3','1:4','2:5','负其它','3球','5球','7+球','平负','负负','胜负'];
					valid_arr['让平+4'] = ['0:4','1:5','负其它','3球','5球','7+球','平负','负负','胜负'];
					valid_arr['让平+5'] = ['0:5','负其它','5球','7+球','平负','负负','胜负'];
					valid_arr['让平+6'] = ['负其它','7+球','平负','负负','胜负'];
					valid_arr['让平+7'] = ['负其它','7+球','平负','负负','胜负'];
				
					valid_arr['让负+1'] = ['0:2','0:3','1:3','0:4','1:4','2:4','0:5','1:5','2:5','负其它','2球','3球','4球','5球','6球','7+球','平负','负负','胜负'];
					valid_arr['让负+2'] = ['0:3','0:4','1:4','0:5','1:5','2:5','负其它','3球','4球','5球','6球','7+球','平负','负负','胜负'];
					valid_arr['让负+3'] = ['0:4','0:5','1:5','负其它','4球','5球','6球','7+球','平负','负负','胜负'];
					valid_arr['让负+4'] = ['0:5','负其它','5球','6球','7+球','平负','负负','胜负'];
					valid_arr['让负+5'] = ['负其它','6球','7+球','平负','负负','胜负'];
					valid_arr['让负+6'] = ['负其它','7+球','平负','负负','胜负'];
					valid_arr['让负+7'] = ['负其它','7+球','平负','负负','胜负'];
				
					valid_arr['让胜-1'] = ['2:0','3:0','3:1','4:0','4:1','4:2','5:0','5:1','5:2','胜其它','2球','3球','4球','5球','6球','7+球','胜胜','负胜','平胜'];
					valid_arr['让胜-2'] = ['3:0','4:0','4:1','5:0','5:1','5:2','胜其它','3球','4球','5球','6球','7+球','胜胜','负胜','平胜'];
					valid_arr['让胜-3'] = ['4:0','5:0','5:1','胜其它','4球','5球','6球','7+球','胜胜','负胜','平胜'];
					valid_arr['让胜-4'] = ['5:0','胜其它','5球','6球','7+球','胜胜','负胜','平胜'];
					valid_arr['让胜-5'] = ['胜其它','6球','7+球','胜胜','负胜','平胜'];
					valid_arr['让胜-6'] = ['胜其它','7+球','胜胜','负胜','平胜'];
					valid_arr['让胜-7'] = ['胜其它','7+球','胜胜','负胜','平胜'];
				
					valid_arr['让平-1'] = ['1:0','2:1','3:2','胜其它','1球','3球','5球','7+球','胜胜','负胜','平胜'];
					valid_arr['让平-2'] = ['2:0','3:1','4:2','胜其它','2球','4球','6球','7+球','胜胜','负胜','平胜'];
					valid_arr['让平-3'] = ['3:0','4:1','5:2','胜其它','3球','5球','7+球','胜胜','负胜','平胜'];
					valid_arr['让平-4'] = ['4:0','5:1','胜其它','4球','6球','7+球','胜胜','负胜','平胜'];
					valid_arr['让平-5'] = ['5:0','胜其它','5球','7+球','胜胜','负胜','平胜'];
					valid_arr['让平-6'] = ['胜其它','6球','7+球','胜胜','负胜','平胜'];
					valid_arr['让平-7'] = ['胜其它','7+球','胜胜','负胜','平胜'];
				
					valid_arr['让负-1'] = [
					  '0:0','1:1','2:2','3:3','平其它',
					  '0:1','0:2','1:2','0:3','1:3','2:3',
					  '0:4','1:4','2:4','0:5','1:5','2:5',
					  '负其它','0球','1球','2球','3球','4球','5球','6球','7+球',
					  '负负','平负','胜负','胜平','平平','负平'
					];
					
					valid_arr['让负-2'] = [
					  '0:0','1:1','2:2','3:3','平其它',
					  '0:1','0:2','1:2','0:3','1:3','2:3',
					  '0:4','1:4','2:4','0:5','1:5','2:5',
					  '负其它','1:0','2:1','3:2','胜其它',
					  '0球','1球','2球','3球','4球','5球','6球','7+球',
					  '负负','平负','胜负','胜平','平平','负平','胜胜','负胜','平胜'
					];
					
					valid_arr['让负-3'] = [
					  '0:0','1:1','2:2','3:3','平其它',
					  '0:1','0:2','1:2','0:3','1:3','2:3',
					  '0:4','1:4','2:4','0:5','1:5','2:5',
					  '负其它','1:0','2:0','2:1','3:1','3:2','4:2','胜其它',
					  '0球','1球','2球','3球','4球','5球','6球','7+球',
					  '负负','平负','胜负','胜平','平平','负平','胜胜','负胜','平胜'
					];
					
					valid_arr['让负-4'] = [
					  '0:0','1:1','2:2','3:3','平其它',
					  '0:1','0:2','1:2','0:3','1:3','2:3',
					  '0:4','1:4','2:4','0:5','1:5','2:5',
					  '负其它','1:0','2:0','2:1','3:0','3:1','3:2','4:1','4:2','5:2','胜其它',
					  '0球','1球','2球','3球','4球','5球','6球','7+球',
					  '负负','平负','胜负','胜平','平平','负平','胜胜','负胜','平胜'
					];
					
					valid_arr['让负-5'] = [
					  '0:0','1:1','2:2','3:3','平其它',
					  '0:1','0:2','1:2','0:3','1:3','2:3',
					  '0:4','1:4','2:4','0:5','1:5','2:5',
					  '负其它','1:0','2:0','2:1','3:0','3:1','3:2','4:0','4:1','4:2','5:1','5:2','胜其它',
					  '0球','1球','2球','3球','4球','5球','6球','7+球',
					  '负负','平负','胜负','胜平','平平','负平','胜胜','负胜','平胜'
					];
					
					valid_arr['让负-6'] = [
					  '0:0','1:1','2:2','3:3','平其它',
					  '0:1','0:2','1:2','0:3','1:3','2:3',
					  '0:4','1:4','2:4','0:5','1:5','2:5',
					  '负其它','1:0','2:0','2:1','3:0','3:1','3:2','4:0','4:1','4:2','5:0','5:1','5:2','胜其它',
					  '0球','1球','2球','3球','4球','5球','6球','7+球',
					  '负负','平负','胜负','胜平','平平','负平','胜胜','负胜','平胜'
					];
					
					valid_arr['让负-7'] = [
					  '0:0','1:1','2:2','3:3','平其它',
					  '0:1','0:2','1:2','0:3','1:3','2:3',
					  '0:4','1:4','2:4','0:5','1:5','2:5',
					  '负其它','1:0','2:0','2:1','3:0','3:1','3:2','4:0','4:1','4:2','5:0','5:1','5:2','胜其它',
					  '0球','1球','2球','3球','4球','5球','6球','7+球',
					  '负负','平负','胜负','胜平','平平','负平','胜胜','负胜','平胜'
					];
					valid_arr['0:0'] = ['0球','平平'];
					valid_arr['1:1'] = ['2球','平平','负平','胜平'];
					valid_arr['2:2'] = ['4球','平平','负平','胜平'];
					valid_arr['3:3'] = ['6球','平平','负平','胜平'];
					valid_arr['平其它'] = ['7+球','平平','负平','胜平'];
				
					valid_arr['1:0'] = ['1球','胜胜','平胜'];
					valid_arr['2:0'] = ['2球','胜胜','平胜'];
					valid_arr['2:1'] = ['3球','胜胜','平胜','负胜'];
					valid_arr['3:0'] = ['3球','胜胜','平胜'];
					valid_arr['3:1'] = ['4球','胜胜','平胜','负胜'];
					valid_arr['3:2'] = ['5球','胜胜','平胜','负胜'];
					valid_arr['4:0'] = ['4球','胜胜','平胜'];
					valid_arr['4:1'] = ['5球','胜胜','平胜','负胜'];
					valid_arr['4:2'] = ['6球','胜胜','平胜','负胜'];
					valid_arr['5:0'] = ['5球','胜胜','平胜'];
					valid_arr['5:1'] = ['6球','胜胜','平胜','负胜'];
					valid_arr['5:2'] = ['7+球','胜胜','平胜','负胜'];
					valid_arr['胜其它'] = ['7+球','胜胜','平胜','负胜'];
				
					valid_arr['0:1'] = ['1球','平负','负负'];
					valid_arr['0:2'] = ['2球','平负','负负'];
					valid_arr['1:2'] = ['3球','平负','负负','胜负'];
					valid_arr['0:3'] = ['3球','平负','负负'];
					valid_arr['1:3'] = ['4球','平负','负负','胜负'];
					valid_arr['2:3'] = ['5球','平负','负负','胜负'];
					valid_arr['0:4'] = ['4球','平负','负负'];
					valid_arr['1:4'] = ['5球','平负','负负','胜负'];
					valid_arr['2:4'] = ['6球','平负','负负','胜负'];
					valid_arr['0:5'] = ['5球','平负','负负'];
					valid_arr['1:5'] = ['6球','平负','负负','胜负'];
					valid_arr['2:5'] = ['7+球','平负','负负','胜负'];
					valid_arr['负其它'] = ['7+球','平负','负负','胜负'];
				
					valid_arr['0球'] = ['平平'];
					valid_arr['1球'] = ['胜胜','平胜','平负','负负'];
					valid_arr['2球'] = ['胜胜','胜平','平胜','平平','负平','负负'];
					valid_arr['3球'] = ['胜胜','胜负','平胜','平负','负胜','负负'];
					valid_arr['4球'] = ['胜胜','胜平','胜负','平胜','平平','平负','负胜','负平','负负'];
					valid_arr['5球'] = ['胜胜','胜负','平胜','平负','负胜','负负'];
					valid_arr['6球'] = ['胜胜','胜平','胜负','平胜','平平','平负','负胜','负平','负负'];
					valid_arr['7+球'] = ['胜胜','胜平','胜负','平胜','平平','平负','负胜','负平','负负'];
				
					valid_arr['胜胜'] = ['胜胜'];
					valid_arr['胜平'] = ['胜平'];
					valid_arr['胜负'] = ['胜负'];
					valid_arr['平胜'] = ['平胜'];
					valid_arr['平平'] = ['平平'];
					valid_arr['平负'] = ['平负'];
					valid_arr['负胜'] = ['负胜'];
					valid_arr['负平'] = ['负平'];
					valid_arr['负负'] = ['负负'];
				
				let new_arr = [];
				_matches.forEach((match, k) => {
				  let combinated_match = this.p_playCombination(match);
				  let checked_match = [];
				  combinated_match.forEach(one => {
					const ret = this.p_checkValidCombination(one, valid_arr);
					if (ret) {
					  checked_match.push(one);
					}
				  });
				  
				  if (checked_match.length > 0) {
					new_arr.push(checked_match);
				  }
				});
				const max_arr = [];
				const min_arr = [];
				new_arr.forEach(match => {
				  const max_min_match = this.p_getMatchMaxMin(match);
				  max_arr.push(max_min_match.max_arr);
				  min_arr.push(max_min_match.min_arr);
				});
				
				return { max_matchs: max_arr, min_matchs: min_arr };
			
			},
			p_getMatchMaxMin(match_arr) {
			  let max = -1;
			  let min = Infinity;
			  let max_line = [];
			  let min_line = [];
			
			  for (const one of match_arr) {
				let rate = 0;
				for (const v of one) {
				  rate += parseFloat(v.odds);
				}
				if (rate > max) {
				  max = rate;
				  max_line = one;
				}
				if (rate < min) {
				  min = rate;
				  min_line = one;
				}
			  }
			
			  return {
				max_arr: max_line,
				max_rate: max,
				min_arr: min_line,
				min_rate: min
			  };
			},
			p_getMultArray(check_arr1, check_arr2) {
			  const new_arr = [];
			  for (const v1 of check_arr1) {
				for (const v2 of check_arr2) {
				  if (v1 === v2) {
					new_arr.push(v1);
				  }
				}
			  }
			  return new_arr;
			},
			p_checkValidCombination(uncheck_arr, valid_arr) {
			  let init = false;
			  let save_check_arr = [];
			
			  for (const unval of uncheck_arr) {
				if (!init) {
				  if (!(unval.option in valid_arr)) {
					return false;
				  }
				  save_check_arr = valid_arr[unval.option];
				  init = true;
				} else {
				  if (!save_check_arr.includes(unval.option)) {
					return false;
				  }
				  save_check_arr = this.p_getMultArray(
					save_check_arr,
					valid_arr[unval.option] || []
				  );
				}
			  }
			
			  return true;
			},
			p_playCombination(arr) {
			  let new_arr = [];
			  for (let i = 1; i <= arr.length; i++) {
				const add_arr = this.p_generate_combinations(arr, i, 1);
				new_arr = new_arr.concat(add_arr);
			  }
			  return new_arr;
			},
			lotteryLimit(_money, _count){
				if(_count == 1){
					if(_money > 100000){
						return 100000;
					}
				}else if( _count == 2 || _count == 3){
					if(_money > 200000){
						return 200000;
					}
				}else if( _count == 4 || _count == 5){
					if(_money > 500000){
						return 500000;
					}
				}else{
					if(_money > 1000000){
						return 1000000;
					}
				}
				return _money;
			},
			myFixed(_num){
				_num = parseFloat(_num);
				var dt = _num.toFixed(8).toString();
				let pos = -1;
				if (dt.indexOf('万') > 0) return _num; //如果数据中在万以上，就不处理
				if (dt.indexOf('.') < 0) { //如果没有小数点呢？
					pos = dt.length;
				} else {
					pos = dt.indexOf('.') + 3;
				}
				var key = dt.charAt(pos);
				var vals = '';
				if (key < 5) {
					vals = dt.substr(0, pos);
				} else if (key > 5) {
					vals = parseFloat(dt.substr(0, pos)) + 0.01;
				} else {
					if (dt.charAt(pos - 1) % 2) {
						vals = parseFloat(dt.substr(0, pos)) + 0.01;
					} else {
						vals = parseFloat(dt.substr(0, pos));
					}
				}
				//vals已经是2位小数，使用toFixed(2)使之补零操作
				return (parseFloat(vals) * 1).toFixed(2);
			},
		}
	}
</script>

